import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Toolbar, AppBar, IconButton, Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import LinkIcon from "@material-ui/icons/Link";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import ListIcon from "@material-ui/icons/List";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import CodeIcon from "@material-ui/icons/Code";

const useStyles = makeStyles((theme) => ({
  postToolbar: {
    background: theme.palette.primary.dark,
    width: "100%",
  },
  postToolbarGrid: {
    justifyContent: "center",
  },
}));

const PostToolbar = ({ setPost }) => {
  const classes = useStyles();

  const handleToolAction = (type) => {
    switch (type) {
      case "heading":
        setPost((prevState) => prevState.concat("\n #### Heading "));
        break;
      case "link":
        setPost((prevState) =>
          prevState.concat(" [Link Title](Link Address) ")
        );
        break;
      case "image":
        setPost((prevState) =>
          prevState.concat(" ![Img Alt Text](Image Address) ")
        );
        break;
      case "unorderedList":
        setPost((prevState) =>
          prevState.concat("\n* Item\n* Item 2\n* Item 3")
        );
        break;
      case "orderedList":
        setPost((prevState) =>
          prevState.concat("\n1. Item 1\n2. Item 2\n3. Item 3")
        );
        break;
      case "italic":
        setPost((prevState) => prevState.concat(" *Italic Text* "));
        break;
      case "bold":
        setPost((prevState) => prevState.concat(" **Bold Text** "));
        break;
      case "code":
        setPost((prevState) =>
          prevState.concat("\n~~~\nA sample piece of text.\n~~~")
        );

        break;
      default:
        return;
    }
  };
  return (
    <AppBar position="static" className={classes.postToolbar}>
      <Toolbar variant="dense">
        <Grid container className={classes.postToolbarGrid}>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-heading-tool"
              onClick={() => handleToolAction("heading")}
            >
              <AddIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-link-tool"
              onClick={() => handleToolAction("link")}
            >
              <LinkIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-image-tool"
              onClick={() => handleToolAction("image")}
            >
              <AddPhotoAlternateIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-code-tool"
              onClick={() => handleToolAction("code")}
            >
              <CodeIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-unorderedList-tool"
              onClick={() => handleToolAction("unorderedList")}
            >
              <ListIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-orderedList-tool"
              onClick={() => handleToolAction("orderedList")}
            >
              <FormatListNumberedIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-italic-tool"
              onClick={() => handleToolAction("italic")}
            >
              <FormatItalicIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              color="inherit"
              aria-label="add-bold-tool"
              onClick={() => handleToolAction("bold")}
            >
              <FormatBoldIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default PostToolbar;
